module.exports = __webpack_public_path__ + "img/square.ec7d4ddc.svg";